import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { EMPTY, from, Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { BsHotToastService } from 'src/app/core/services/hot-toast/hot-toast.service';
import { USE_ALT_TOKEN } from 'src/shared/constants/alt-token-http-context';
import { MessagesStateService } from '../../../service/messages-state/messages-state.service';

const statusCodeMessages: { [key: string | number]: string } = {
	0: 'Ocorreu um erro, por favor tente novamente mais tarde.',
	500: 'Ocorreu um erro, por favor tente novamente mais tarde.',
	405: 'Ocorreu um erro, por favor tente novamente mais tarde.',
	403: 'Acesso negado.',
};

const UNAUTHORIZED = 401;
const LOCKED = 423;
const LOGIN_URL = 'auth';

@Injectable()
export class ErrorHandleInterceptor implements HttpInterceptor {

	constructor(
		private bsHotToast: BsHotToastService,
		private injector: Injector,
	) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		const isAltToken = req.context.get(USE_ALT_TOKEN);

		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				if (
					error.status === UNAUTHORIZED &&
					!error.url?.includes(LOGIN_URL)
				) {

					if (isAltToken) {
						const chatService = this.injector.get(MessagesStateService);

						chatService.setUnauthorized();

						this.bsHotToast.showError(
							'Token Chatbot expirado, por favor, faça login novamente.',
						);

						return EMPTY;
					}

					this.bsHotToast.showError(
						'Token expirado, por favor, faça login novamente.',
					);

					return EMPTY;
				}

				if (error.status === LOCKED) {
					this.bsHotToast.showError(
						error.error?.message ?? 'Recurso bloqueado.',
					);

					return throwError(() => ({ status: LOCKED }));
				}

				const errorMessage = statusCodeMessages[error.status];

				if (errorMessage) {
					this.bsHotToast.showError(errorMessage);
					return EMPTY;
				}

				const handleBackendError = (backendError: any) => {					
					if (
						backendError &&
						Array.isArray(backendError)
					) {

						backendError.forEach((err: any) => {
							if (err?.message) {
								this.bsHotToast.showError(err.message);
							}
						});

						return;
					}

					if (typeof backendError?.message === 'string') {
						this.bsHotToast.showError(backendError.message);
						return;
					}

					const fallbackMessage =
						error.message || 'Ocorreu um erro inesperado.';

					this.bsHotToast.showError(fallbackMessage);
				};

				if (error.error instanceof Blob) {
					return from(error.error.text()).pipe(
						mergeMap((text) => {
							let parsed: any = null;

							try {
								parsed = JSON.parse(text);
							} catch { }

							handleBackendError(parsed);
							return EMPTY;
						}),
					);
				}

				if (typeof error.error === 'string') {
					let parsed: any = null;

					try {
						parsed = JSON.parse(error.error);
					} catch { }

					handleBackendError(parsed);

					return EMPTY;
				}

				handleBackendError(error.error);
				return EMPTY;
			}),
		);
	}
}